export interface SubscriptionData {
  subscriptionStart: string;
  periodStart: string;
  periodDuration: string | number;
  trialDuration: string | number;
  cancelInProgress: boolean;
  isActive: boolean;
  tokenTrialActive: boolean;
  tokens: number;
  channel: string;
  /**
   * Se l'API lo manda: true = riga StripeCustomers, false = non c'è.
   * Assente: la webapp lo scopre con stripe-customer-session.
   */
  hasStripeCustomer?: boolean;
  idUtente?: string;
  updatedAt?: string;
  email: string;
  tier: number;
  totalAppointments?: number;
  essentialVersionLimits: {
    pazienti: number;
    appuntamenti?: number;
  };
  promoCode?: { code: string; expiresAt: string | number };
  /** Override estate: isActive finto da API, non abbonamento reale. */
  summerUnlock?: boolean;
  summerUnlockEndsAt?: string;
}

export const SUBSCRIPTION_TIERS = {
  premium: 1,
  lite: 2,
  essential: 3,
} as const;

export type CancelPaypalSubscriptionInput = {
  reason: string;
  detail?: string;
};
